import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Dashboard } from "@/pages/Dashboard";
import { Settings } from "@/pages/Settings";
import { Import } from "@/pages/Import";
import { TestTools } from "@/pages/TestTools";
import { SyncHistory } from "@/pages/SyncHistory";

function App() {
  return (
    <div className="App min-h-screen bg-stone-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="settings" element={<Settings />} />
            <Route path="import" element={<Import />} />
            <Route path="test-tools" element={<TestTools />} />
            <Route path="history" element={<SyncHistory />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
